import { create } from "zustand"
import { persist, createJSONStorage } from "zustand/middleware"

interface OffersFunnelState {
  /** Index of the offer currently shown in the additional-offers funnel. */
  step: number
  setStep: (step: number) => void
  reset: () => void
}

/**
 * Current position in the additional-offers funnel. Persisted to sessionStorage
 * so a mid-funnel refresh resumes on the same offer instead of restarting; it's
 * reset to 0 once the funnel hands off to /create-account.
 */
export const useOffersFunnelStore = create<OffersFunnelState>()(
  persist(
    (set) => ({
      step: 0,
      setStep: (step) => set({ step }),
      reset: () => set({ step: 0 }),
    }),
    {
      name: "bp-offers-funnel",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)
